import DeviceManager from '../utils/device-manager';
import $ from "jquery";
import Flickity from "flickity-fade";
import "flickity-imagesloaded";

class GallerySlider {
    constructor($el) {
        this.$el = $el;

        this.options = {
            autoPlay: false,
            pageDots: true,
            wrapAround: true,
            prevNextButtons: false,
            freeScroll: false,
            cellSelector: '.section-gallery__item',
            cellAlign: 'left',
            imagesLoaded: true,
        };

        if(this.$el.length) {
            this._init();
            this._bindEvents();
        }
    }

    _init() {
        this.$slides = this.$el.find('.section-gallery__item');
        this.slidesCount = this.$slides.length;
        this.slider = new Flickity(this.$el[0], this.options);

        // if (document.body.clientWidth < 992 && this.slidesCount > 1) {
        // } else {
        //     this._destroy();
        // }
    }

    _bindEvents() {
        this._onBreakpointChangeFn = this._onBreakpointChange.bind(this);

        DeviceManager.on('device-manager:breakpointChange', this._onBreakpointChangeFn);
    }
    
    _destroy() {
        if(this.slider) {
            this.slider.destroy();
            this.slider = null;
        }
    }

    _onBreakpointChange() {
        this.slider = new Flickity(this.$el[0], this.options);
    }
}

export default GallerySlider;